import { z } from 'zod';
import { DbJsonSchema } from '../../../dbJsonSchemas.js';
import { customFieldUiCollection } from '../../schema/customField.js';
export const stripeConfig = z.object({
    isExtendedAuthAllowed: z.boolean(),
    idFromPlatform: z.string(), // account_id
    id: z.number(),
});
export const settings = z.object({
    storeId: z.number(),
    storeUrl: z.string().optional(),
    storeName: z.string().optional(),
    storefrontId: z.string(),
    isActive: z.boolean(),
    exchangeOrderPrefix: z.string().optional(),
    isClaimImageFromCustomerRequired: z.boolean(),
    stripeConfig: stripeConfig.optional(),
    localizeKey: z.string().optional(),
    registrations: z.object({
        isEnabled: z.boolean(),
        shouldCollectProofOfPurchase: z.boolean(),
        shouldCollectAddress: z.boolean(),
        isStartWarrantyClaimEnabled: z.boolean(),
        customFields: customFieldUiCollection,
        storeSalesChannels: z.array(z.object({
            id: z.number(),
            name: z.string(),
        })),
    }),
    warranty: z.object({
        isEnabled: z.boolean(),
    }),
    return: z.object({
        isEnabled: z.boolean(),
        isGiftCardEnabled: z.boolean(),
        isExchangeEnabled: z.boolean(),
        isRefundEnabled: z.boolean(),
    }),
    theme: DbJsonSchema.StoreUiConfig.customerUiConfigSchema,
});
//# sourceMappingURL=settings.js.map